class MobileNavDrawer extends DrawerElement {
  constructor() {
    super();
    this.subMenuTriggers = this.querySelectorAll('.submenu-trigger');
    this.currentMenu = this.querySelector('.menu-drawer__menu');
    this.currentMenuTrigger = this.querySelector('button[data-menu-trigger]');
    this.menu = this.querySelector('[data-mobile-menu]');

    this.subMenuTriggers.forEach((subMenuTrigger) =>
      subMenuTrigger.addEventListener('click', this.onSubMenuTriggerClick.bind(this)),
    );
    this.querySelectorAll('button[data-back]').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
    this.querySelectorAll('button[data-close]').forEach((button) =>
      button.addEventListener('click', this.onDrawCloseEvent.bind(this)),
    );
    this.querySelectorAll('button[data-menu-trigger]').forEach((button) =>
      button.addEventListener('click', this.toggleMenus.bind(this)),
    );
    this.querySelectorAll('[data-aux-menu-trigger]').forEach((element) => {
      element.addEventListener('click', this.handleAuxTriggerClick.bind(this));
    });
    this.querySelectorAll('[data-level-two-list]').forEach((list) =>
      list.addEventListener('scroll', this.onmenuScroll.bind(this)),
    );
    this.addEventListener('drawer:close', this.onDrawCloseEvent.bind(this));

    window.addEventListener('resize', this.onResize);
  }

  onDrawCloseEvent() {
    if (this.activeSubMenu) {
      this.classList.remove('level-2-active');
      this.activeSubMenu.classList.add('hidden');
      this.activeSubMenu.classList.replace('opactiy-100', 'opacity-0');
      this.activeSubMenu = null;
      window.clearFocusQueue();
    }

    const shopMenu = this.querySelector('.menu-drawer__menu');
    const shopTrigger = this.querySelector('button[data-menu-trigger]');
    if (this.currentMenu !== shopMenu) {
      this.currentMenu.classList.replace('opacity-100', 'opacity-0');
      this.currentMenu.classList.add('hidden');
      shopMenu.classList.replace('opacity-0', 'opacity-100');
      shopMenu.classList.remove('hidden');
      this.currentMenu = shopMenu;

      this.currentMenuTrigger.classList.remove('text-black');
      this.currentMenuTrigger.classList.add('text-gray-900');
      shopTrigger.classList.remove('text-gray-900');
      shopTrigger.classList.add('text-black');
      this.currentMenuTrigger = shopTrigger;
    }
  }

  activate() {
    console.log('activate mobile nav');
    this.setAttribute('aria-hidden', false);
    this.style.zIndex = 1;
    this.classList.remove('hidden');
  }

  onmenuScroll() {
    const menuList = event.currentTarget;
    if (menuList.scrollTop > 0) {
      this.activeSubMenu.classList.add('is-scrolling');
    } else {
      this.activeSubMenu.classList.remove('is-scrolling');
    }
  }

  focusLevelOne(triggerElement) {
    window.trapFocus(this, null, triggerElement);
  }

  resetSubNavs() {}

  escape() {
    if (this.activeSubMenu) {
      console.log('go back to level one');
      this.closeSubMenu();
    } else {
      console.log('close panel with escape');
      window.panelManager.dispatch('CLOSE_PANEL');
    }
  }

  toggleMenus(event) {
    const oldMenu = this.currentMenu;
    const oldMenuTrigger = this.currentMenuTrigger;
    const menuId = event.currentTarget.dataset.menuTrigger;
    const newActiveMenu = this.querySelector(`[data-menu-id="${menuId}"]`);

    if (this.currentMenu === newActiveMenu) {
      // window.trapFocus(this.currentMenu, null, this.currentMenuTrigger, false);
      return;
    }

    oldMenu.classList.replace('opacity-100', 'opacity-0');
    waitForTransitionEnd(this.currentMenu).then(() => {
      if (oldMenu.classList.contains('opacity-0')) {
        oldMenu.classList.add('hidden');
      }
    });

    oldMenuTrigger.classList.remove('text-black');
    oldMenuTrigger.classList.add('text-gray-900');

    this.currentMenuTrigger = event.currentTarget;
    this.currentMenuTrigger.classList.remove('text-gray-900');
    this.currentMenuTrigger.classList.add('text-black');

    newActiveMenu.classList.remove('hidden');
    requestAnimationFrame(() => {
      newActiveMenu.classList.replace('opacity-0', 'opacity-100');
      waitForTransitionEnd(newActiveMenu).then(() => {
        console.log('trap focus', 'new active menu');
        const focusElement = window.focusManager.getFocusableElements(newActiveMenu)[0];
        window.trapFocus(this, focusElement, this.currentMenuTrigger);
      });
    });
    this.currentMenu = newActiveMenu;

    if (this.currentMenuTrigger.dataset.includeAux !== undefined) {
      this.querySelector('.mobile-aux').classList.remove('hidden');
    } else {
      this.querySelector('.mobile-aux').classList.add('hidden');
    }
  }

  onSubMenuTriggerClick(event) {
    const clickedButton = event.currentTarget;
    this.activeSubMenu = this.querySelector(`#${clickedButton.getAttribute('aria-controls')}`);
    this.activeSubMenu.classList.remove('hidden');
    this.classList.add('level-2-active');
    requestAnimationFrame(() => {
      this.activeSubMenu.classList.remove('opacity-0');
      waitForTransitionEnd(this.activeSubMenu).then(() => {
        console.log('trap focus', 'active sub menu');
        window.trapFocus(this.activeSubMenu, null, clickedButton, false);
      });
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    this.closeSubMenu();
  }

  closeSubMenu() {
    this.classList.remove('level-2-active');
    const subMenu = this.activeSubMenu;
    requestAnimationFrame(() => {
      subMenu.classList.add('opacity-0');
    });
    waitForTransitionEnd(subMenu).then(() => {
      subMenu.classList.add('hidden');
      window.releaseFocus();
    });
    this.activeSubMenu = null;
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    this.classList.add('level-2-active');
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  handleAuxTriggerClick(event) {
    event.currentTarget.parentElement.classList.toggle('expanded');
  }

  onResize = () => {
    if (window.innerWidth >= 1200) {
      // this.onBackgroundClick();
    }
  };
}

customElements.define('mobile-nav-drawer', MobileNavDrawer);
